import React, { useEffect, useState } from 'react';
import { Container, AppBar, Toolbar, Typography, TextField, CircularProgress, Tooltip, Box, InputAdornment, IconButton, Button, Table, TableHead, TableBody, TableRow, TableCell, Modal, Paper, Chip, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LockIcon from '@mui/icons-material/Lock';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Registration() {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [ddlClass, setDdlClass] = useState([]);
  const [registrationData, setRegistrationData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRegistrationId, setSelectedRegistrationId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  // State for Info Modal
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  let navigate = useNavigate();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };


  const fetchddlClass = async () => {
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class: ${response.status}`);
      }
      const data = await response.json();
      setDdlClass(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchRegistration = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Registration/GetRegistration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setRegistrationData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleDelete = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Registration/Id?Id=${selectedRegistrationId}`;
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (response.ok) {
        // If deletion is successful, refresh the registration data
        fetchRegistration();
        handleCloseModal();
        setSnackbarMessage('Registration deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success")
      } else {
        console.error('Failed to delete registration');
        // alert('Failed to delete registration');
        setSnackbarMessage('Failed to delete registration');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")

      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleShowModal = (registrationId) => {
    setSelectedRegistrationId(registrationId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRegistrationId(null);
  };

  useEffect(() => {
    fetchRegistration();
    Authorizer();
    fetchddlClass();
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase()); // Update the search query state
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const filteredData = registrationData
    .filter(registration =>
      registration.registrationNo.toLowerCase().includes(searchQuery) ||
      registration.name.toLowerCase().includes(searchQuery) ||
      registration.mobileNo.includes(searchQuery)
    );
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  // Info sections data for the Info Modal
  const infoSections = [
    {
      icon: <AssignmentIcon sx={{ color: "#1976d2", fontSize: 22 }} />,
      title: "Table Columns",
      color: "#e3f2fd",
      borderColor: "#1976d2",
      items: [
        { label: "Student Name", desc: "Full name of the student being registered." },
        { label: "Class", desc: "The class the student is applying for, resolved from the class list." },
        { label: "Mobile No.", desc: "Contact number associated with the registration." },
        { label: "Registration No.", desc: "Unique system-generated registration identifier." },
        { label: "Registration Date", desc: "The date on which the registration was created." },
        { label: "Registration Fee", desc: "Fee amount collected at the time of registration (shown to 2 decimal places)." },
        { label: "Action", desc: "Edit or Delete buttons for managing each registration record." },
      ],
    },
    {
      icon: <ManageSearchIcon sx={{ color: "#7b1fa2", fontSize: 22 }} />,
      title: "Search & Pagination",
      color: "#f3e5f5",
      borderColor: "#7b1fa2",
      items: [
        { label: "Search Bar", desc: "Filter records in real time by Student Name, Registration No., or Mobile Number." },
        { label: "Rows per Page", desc: "Choose how many records to display per page: 5, 10, 25, or 50." },
        { label: "Prev / Next", desc: "Navigate between pages of results. Buttons are disabled at the first and last pages." },
      ],
    },
    {
      icon: <PersonIcon sx={{ color: "#e65100", fontSize: 22 }} />,
      title: "Actions",
      color: "#fff3e0",
      borderColor: "#e65100",
      items: [
        { label: "Add", desc: "Opens the Add Registration form to create a new registration record." },
        { label: "Edit", desc: "Opens the Update Registration form pre-filled with the selected record's data." },
        { label: "Delete", desc: "Prompts a confirmation dialog before permanently removing the registration record." },
      ],
    },
    {
      icon: <LockIcon sx={{ color: "#2e7d32", fontSize: 22 }} />,
      title: "Permissions",
      color: "#e8f5e9",
      borderColor: "#2e7d32",
      items: [
        { label: "Add Permission", desc: "The Add button is enabled only if your account has Write (uWrite) permission for this module." },
        { label: "Edit Permission", desc: "The Edit button is enabled only if your account has Modify (uModify) permission." },
        { label: "Delete Permission", desc: "The Delete button is enabled only if your account has Delete (uDelete) permission." },
        { label: "Unauthorized", desc: "Hovering over a disabled button shows a tooltip explaining you are not authorized for that action." },
      ],
    },
  ];

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          {/* Title + Info Button */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
              Registration Details
            </Typography>

            {/* Info Button */}
            <Tooltip title="View page information & guide" arrow placement="right">
              <IconButton
                onClick={() => setInfoModalOpen(true)}
                size="small"
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  border: "1.5px solid rgba(255,255,255,0.25)",
                  borderRadius: "50%",
                  width: 32,
                  height: 32,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    borderColor: "#64B5F6",
                    color: "#ffffff",
                    boxShadow: "0 0 0 3px rgba(100,181,246,0.25)",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <InfoOutlinedIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <TextField
            id="search"
            label="Search"
            variant="outlined"
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <div>
            <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span>

              <Button variant="contained" color="primary" onClick={() => navigate('/addregistration')} style={{
                marginRight: '10px', width: "90px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
                disabled={!canAdd}>
                Add
              </Button></span></Tooltip>
            {/* <Button variant="contained" color="secondary" onClick={() => navigate('/scanregistration')} style={{width: "90px",
              height: "50px",
              padding: "10px 0",
              fontWeight:'bold'}}>
              Scan
            </Button> */}
          </div>
        </div>

        <Table
          sx={{
            minWidth: 650,
            border: '1px solid #ccc',
            '& .MuiTableCell-root': {
              borderRight: '1px solid #ccc',
              fontSize: '1rem',
            },
            '& .MuiTableHead-root .MuiTableCell-root': {
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Student Name
              </TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Class
              </TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Mobile No.
              </TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Registration No.
              </TableCell>
              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Registration Date
              </TableCell>


              {/* <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                Registration Fee
              </TableCell> */}

              <TableCell sx={{ borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((registration) => (
                <TableRow key={registration.registrationId} sx={{ borderTop: '1px solid #ccc' }}>
                  <TableCell sx={{ fontSize: '1.1rem' }}>{registration.name}</TableCell>
                  <TableCell sx={{ fontSize: '1.1rem' }}>
                    {ddlClass.find(c => c.classId === registration.classID)?.className || registration.classID}
                  </TableCell>
                  <TableCell sx={{ fontSize: '1.1rem' }}>{registration.mobileNo}</TableCell>
                  <TableCell sx={{ fontSize: '1.1rem' }}>{registration.registrationNo}</TableCell>
                  <TableCell sx={{ fontSize: '1.1rem' }}>{registration.dated}</TableCell>
                  {/* <TableCell sx={{ fontSize: '1.1rem' }}>
                    {registration.regFees.toFixed(2)}
                  </TableCell> */}
                  <TableCell sx={{ fontSize: '1.1rem', textAlign: 'center' }}>
                    <Tooltip title={!canEdit && "You are not Authorized to Edit"} arrow>
                      <span>
                        <Button
                          variant="contained"
                          color="warning"
                          onClick={() => navigate(`/updateregistration/${registration.registrationId}`)}
                          sx={{ marginRight: 1 }}
                          startIcon={<EditIcon />}
                          disabled={!canEdit}
                        >
                          Edit
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
                      <span>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleShowModal(registration.registrationId)}
                          sx={{ marginRight: 1 }}
                          startIcon={<DeleteIcon />}
                          disabled={!canDelete}
                        >
                          Delete
                        </Button>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Registrations Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>

        </Table>

        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}


        {/* Confirmation Modal */}
        <Modal open={showModal} onClose={handleCloseModal} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Delete Confirmation ⚠️
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                Are you sure you want to delete this Registration ?
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button onClick={handleCloseModal} variant="outlined" sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Paper>

      {/* Info Modal */}
      <Modal
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
        aria-labelledby="info-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: 620, md: 680 },
            maxHeight: "85vh",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0 24px 64px rgba(11,31,61,0.22)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Info Modal Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #0B1F40 0%, #1565C0 100%)",
              padding: "16px 20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  backgroundColor: "rgba(255,255,255,0.15)",
                  borderRadius: "50%",
                  width: 36,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
              </Box>
              <Box>
                <Typography id="info-modal-title" variant="h6" sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.2 }}>
                  Registration Details — Guide
                </Typography>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.65)" }}>
                  Complete reference for all features and fields
                </Typography>
              </Box>
            </Box>
           
          </Box>

          {/* Info Modal Scrollable Body */}
          <Box sx={{ overflowY: "auto", p: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Page Overview */}
            <Box
              sx={{
                backgroundColor: "#f0f4ff",
                border: "1px solid #c5d3f0",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Typography variant="body2" sx={{ color: "#1a237e", lineHeight: 1.7 }}>
                The <strong>Registration Details</strong> page displays all student registration records. You can search, paginate, add new registrations, and edit or delete existing ones — subject to your account permissions.
              </Typography>
            </Box>

            {/* Sections */}
            {infoSections.map((section, sIdx) => (
              <Box
                key={sIdx}
                sx={{
                  backgroundColor: section.color,
                  border: `1px solid ${section.borderColor}30`,
                  borderLeft: `4px solid ${section.borderColor}`,
                  borderRadius: 2,
                  p: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                  {section.icon}
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1a1a2e", fontSize: "0.95rem" }}>
                    {section.title}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
                  {section.items.map((item, iIdx) => (
                    <Box key={iIdx} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                      <Chip
                        label={item.label}
                        size="small"
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          height: 22,
                          flexShrink: 0,
                          backgroundColor: `${section.borderColor}18`,
                          color: section.borderColor,
                          border: `1px solid ${section.borderColor}40`,
                          mt: "1px",
                        }}
                      />
                      <Typography variant="body2" sx={{ color: "#424242", lineHeight: 1.5, fontSize: "0.82rem" }}>
                        {item.desc}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}

            {/* Tip Box */}
            <Box
              sx={{
                backgroundColor: "#fffde7",
                border: "1px solid #f9a825",
                borderRadius: 2,
                p: 2,
                display: "flex",
                gap: 1.5,
                alignItems: "flex-start",
              }}
            >
              <Typography sx={{ fontSize: "1.1rem", mt: "1px" }}>💡</Typography>
              <Typography variant="body2" sx={{ color: "#5d4037", lineHeight: 1.65, fontSize: "0.82rem" }}>
                <strong>Pro Tip:</strong> Use the <em>Search</em> bar to quickly find a student by name, registration number, or mobile number. Combine this with the rows-per-page selector to manage large lists efficiently.
              </Typography>
            </Box>

          </Box>

          {/* Info Modal Footer */}
          <Box
            sx={{
              borderTop: "1px solid #e0e0e0",
              px: 2.5,
              py: 1.5,
              display: "flex",
              justifyContent: "flex-end",
              flexShrink: 0,
              backgroundColor: "#fafafa",
            }}
          >
            <Button
              onClick={() => setInfoModalOpen(false)}
              variant="contained"
              color="primary"
              sx={{ fontWeight: 600, px: 3 }}
            >
              Got It
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


    </Container>
  );
}

export default Registration;